import {CheatView} from '@fantasmagames/slot/src/modules/cheat/CheatView';

export class GameCheatView extends CheatView {

	protected initializeCheatsList(): void {
		super.initializeCheatsList();

		if (this._configByCheatName) {
			this._cheats = this._configByCheatName.record;
			delete this._cheats.name;
		}
	}
}



// WEBPACK FOOTER //
// ./src/cheats/GameCheatView.ts